import { useMutation } from '@tanstack/react-query';
import { useContext } from 'react';

import { TicketContext } from '../../contexts/TicketContext';
import { middlelayer } from '../../services/AxiosService';

enum EVENT_QUERY_KEYS {
  SEND_EVENTS = 'send-events',
}

interface Event {
  message: string; // max 5 KB, otherwise will return bad request
  name: string;
  type: 'error';
}

interface SendEventPayload extends Event {
  timestamp: number;
}

export const sendEventsMutationConfig = (hashId: string, jwt: string) => ({
  mutationKey: [EVENT_QUERY_KEYS.SEND_EVENTS],
  mutationFn: (events: Event[]) => middlelayer.post<void, SendEventPayload[]>(
    `/v1/${hashId}/events`,
    events.map(event => ({
      ...event,
      timestamp: Date.now(),
    })),
    {
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    }
  ),
});

export const useSendEventsMutation = () => {
  const { ticket } = useContext(TicketContext);

  const hashId = ticket?.hashId || '';
  const jwt = ticket?.jwt || '';

  const { mutateAsync } = useMutation(sendEventsMutationConfig(hashId, jwt));

  return {
    sendEvents: mutateAsync,
  };
};
